import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationService } from '../services/notificationService';

/**
 * Hook to archive notifications
 * Automatically invalidates related queries on success
 */
export const useArchiveNotifications = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationIds: string[]) =>
      notificationService.archiveNotifications(notificationIds),
    onSuccess: () => {
      // Invalidate notifications list
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
